import React from 'react';
import { createPortal } from 'react-dom';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const totalSteps = 5;

export function WizardPreviewModal({
  open,
  imageUrls,
  captions,
  tenantName,
  tenantLogo,
  onClose,
  onDontShowAgain,
}) {
  const [step, setStep] = React.useState(1);
  const [dontShow, setDontShow] = React.useState(false);

  React.useEffect(() => {
    if (open) {
      setStep(1);
      setDontShow(false);
    }
  }, [open]);

  if (!open) return null;

  const idx = step - 1;
  const imageUrl = imageUrls[idx] || '';
  const caption = captions[idx] || '';

  const handleClose = () => {
    if (dontShow) {
      onDontShowAgain?.();
    }
    onClose?.();
  };

  const modalContent = (
    <div className="modal-backdrop wizard-preview-backdrop">
      <div className="wizard-preview-card">
        <div className="wizard-preview-header">
          <div className="wizard-preview-brand">
            {tenantLogo ? (
              <img src={tenantLogo} alt={tenantName || 'Logo tenant'} />
            ) : (
              <div className="wizard-preview-logo-fallback">W</div>
            )}
            <div className="wizard-preview-brand-text">
              <div className="wizard-preview-title">Wizard immagini</div>
              <div className="wizard-preview-tenant">{tenantName || ''}</div>
            </div>
          </div>
        </div>
        <div className="wizard-preview-media">
          {imageUrl ? (
            <img src={imageUrl} alt={`Foto ${step}`} />
          ) : (
            <span className="muted">Immagine non disponibile</span>
          )}
        </div>
        <div className="wizard-preview-caption">{caption}</div>

        <div className="wizard-preview-nav">
          {step > 1 ? (
            <button
              className="secondary-button"
              type="button"
              onClick={() => setStep((s) => Math.max(1, s - 1))}
            >
              <LeftOutlined /> Indietro
            </button>
          ) : (
            <div className="wizard-nav-spacer" />
          )}
          <span className="wizard-preview-step">{step}/{totalSteps}</span>
          {step < totalSteps ? (
            <button
              className="secondary-button"
              type="button"
              onClick={() => setStep((s) => Math.min(totalSteps, s + 1))}
            >
              Avanti <RightOutlined />
            </button>
          ) : (
            <div className="wizard-nav-spacer" />
          )}
        </div>

        {step === totalSteps && (
          <label className="wizard-preview-optout">
            <input
              type="checkbox"
              checked={dontShow}
              onChange={(e) => setDontShow(e.target.checked)}
            />
            <span>Non visualizzare più</span>
          </label>
        )}

        <div className="wizard-preview-actions">
          <button className="primary-button" type="button" onClick={handleClose}>
            Chiudi
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
}
